import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Button from "../../components/Button/Button";

export default function PendingForm({ onSearch, onReset }) {
  const pendingForm = useSelector((state) => state.pending.pendingForm);

  const { register, handleSubmit, reset } = useForm({
    defaultValues: pendingForm,
  });

  const resetHandler = () => {
    reset({
      orderId: "",
      invoiceNo: "",
      statusCode: "",
      minAmount: "",
      maxAmount: "",
      startDate: "",
      endDate: "",
    });

    onReset();
  };

  return (
    <form onSubmit={handleSubmit(onSearch)} onReset={resetHandler}>
      <MDBContainer className="border-top p-4 grey-text">
        <MDBRow className="create-row-gap">
          <MDBCol md="4">
            <label>Order Number</label>
            <input
              placeholder="Order Number"
              className="form-control"
              {...register("orderId")}
            />
          </MDBCol>
          <MDBCol md="4">
            <label>Invoice No</label>
            <input
              placeholder="Invoice No"
              className="form-control"
              {...register("invoiceNo")}
            />
          </MDBCol>
          <MDBCol md="4">
            <label>Min Amount</label>
            <input
              type="number"
              placeholder="Min Amount"
              className="form-control"
              {...register("minAmount")}
              onKeyDown={(e) => {
                if (
                  isNaN(e.key) &&
                  !(
                    e.key === "Backspace" ||
                    e.key === "Tab" ||
                    e.key === "Enter"
                  )
                )
                  e.preventDefault();
              }}
            />
          </MDBCol>
          <MDBCol md="4">
            <label>Max Amount</label>
            <input
              type="number"
              placeholder="Max Amount"
              className="form-control"
              {...register("maxAmount")}
              onKeyDown={(e) => {
                if (
                  isNaN(e.key) &&
                  !(
                    e.key === "Backspace" ||
                    e.key === "Tab" ||
                    e.key === "Enter"
                  )
                )
                  e.preventDefault();
              }}
            />
          </MDBCol>
          <MDBCol md="4">
            <label>Start Date</label>
            <input
              placeholder="Start Date"
              type="date"
              className="form-control"
              {...register("startDate")}
            />
          </MDBCol>
          <MDBCol md="4">
            <label>End Date</label>
            <input
              placeholder="End Date"
              type="date"
              className="form-control"
              {...register("endDate")}
            />
          </MDBCol>
          <MDBCol md="4">
            <label>Status</label>
            <select
              className="browser-default custom-select"
              {...register("statusCode")}
            >
              <option value="">ALL</option>
              <option value="0">Initial</option>
              <option value="200">Success</option>
              <option value="407">Expired</option>
              <option value="100">Failed</option>
            </select>
          </MDBCol>
          <MDBCol md="12">
            <MDBContainer>
              <MDBRow end>
                <Button text="RESET" type="reset" small secondary />
                <div className="ml-3">
                  <Button text="SEARCH" icon="search" type="submit" small />
                </div>
              </MDBRow>
            </MDBContainer>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </form>
  );
}
